// extracted by mini-css-extract-plugin
export default {"calculatorBox":"calculator_calculatorBox__G4F+P","dark":"calculator_dark__e4-uu","light":"calculator_light__9W0Xn","disclaimer":"calculator_disclaimer__gcde0"};